const EGFR_formuls = {
  MDRD: {
    Female: {
      calc: (creatinine, age) =>
        175 * creatinine ** -1.154 * age ** -0.203 * 0.742
    },
    Male: {
      calc: (creatinine, age) => 175 * creatinine ** -1.154 * age ** -0.203
    }
  },
  'CKD-EPI': {
    Female: {
      calc: (creatinine, age) =>
        142 *
        Math.min(creatinine / 0.7, 1) ** -0.241 *
        Math.max(creatinine / 0.7, 1) ** -1.2 *
        0.9938 ** age *
        1.012
    },
    Male: {
      calc: (creatinine, age) =>
        142 *
        Math.min(creatinine / 0.9, 1) ** -0.302 *
        Math.max(creatinine / 0.9, 1) ** -1.2 *
        0.9938 ** age
    }
  }
};

export { EGFR_formuls };
